import { Box, chakra } from '@chakra-ui/react';
import { NavBar } from '../features/header/NavBar.tsx';
import { useLayoutStore } from '../stores/layoutStore.ts';
import { Outlet } from 'react-router-dom';

type Props = {
  forceUnauthenticatedNav?: boolean;
};
const Layout = (props: Props) => {
  const layoutStore = useLayoutStore();

  return (
    <chakra.div paddingBottom={'30px'}>
      <NavBar forceUnauthenticatedNav={props.forceUnauthenticatedNav} />
      <chakra.div width={'100%'} p={1}>
        <Outlet />
      </chakra.div>

      {layoutStore.isDataDisplayOpen && <Box paddingBottom={'35vh'}></Box>}
      {layoutStore.isExpanderRendered && <Box paddingBottom={'35px'}></Box>}
    </chakra.div>
  );
};
export default Layout;
